var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        "el-col",
        [
          _c(
            "el-form",
            {
              ref: "titleForm",
              attrs: {
                model: _vm.titleForm,
                "label-width": "80px",
                size: "mini",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("show"),
                      expression: "showProperty('show')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.show") },
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      on: {
                        change: function ($event) {
                          return _vm.changeTitleStyle("show")
                        },
                      },
                      model: {
                        value: _vm.titleForm.show,
                        callback: function ($$v) {
                          _vm.$set(_vm.titleForm, "show", $$v)
                        },
                        expression: "titleForm.show",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.show")) + "\n        ")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.titleForm.show,
                      expression: "titleForm.show",
                    },
                  ],
                },
                [
                  !_vm.batchOptStatus
                    ? _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showProperty("title"),
                              expression: "showProperty('title')",
                            },
                          ],
                          staticClass: "form-item",
                          attrs: { label: _vm.$t("chart.title") },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              size: "mini",
                              placeholder: _vm.$t("chart.title"),
                              clearable: "",
                            },
                            on: {
                              blur: function ($event) {
                                return _vm.changeTitleStyle("title")
                              },
                              input: function ($event) {
                                return _vm.inputOnInput($event)
                              },
                            },
                            model: {
                              value: _vm.titleForm.title,
                              callback: function ($$v) {
                                _vm.$set(_vm.titleForm, "title", $$v)
                              },
                              expression: "titleForm.title",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("fontFamily"),
                          expression: "showProperty('fontFamily')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.font_family") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: _vm.$t("chart.font_family") },
                          on: {
                            change: function ($event) {
                              return _vm.changeTitleStyle("fontFamily")
                            },
                          },
                          model: {
                            value: _vm.titleForm.fontFamily,
                            callback: function ($$v) {
                              _vm.$set(_vm.titleForm, "fontFamily", $$v)
                            },
                            expression: "titleForm.fontFamily",
                          },
                        },
                        _vm._l(_vm.fontFamily, function (option) {
                          return _c("el-option", {
                            key: option.value,
                            attrs: { label: option.name, value: option.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("fontSize"),
                          expression: "showProperty('fontSize')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.text_fontsize") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: _vm.$t("chart.text_fontsize"),
                            size: "mini",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeTitleStyle("fontSize")
                            },
                          },
                          model: {
                            value: _vm.titleForm.fontSize,
                            callback: function ($$v) {
                              _vm.$set(_vm.titleForm, "fontSize", $$v)
                            },
                            expression: "titleForm.fontSize",
                          },
                        },
                        _vm._l(_vm.fontSize, function (option) {
                          return _c("el-option", {
                            key: option.value,
                            attrs: { label: option.name, value: option.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("color"),
                          expression: "showProperty('color')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.text_color") },
                    },
                    [
                      _c("el-color-picker", {
                        staticClass: "color-picker-style",
                        attrs: { predefine: _vm.predefineColors },
                        on: {
                          change: function ($event) {
                            return _vm.changeTitleStyle("color")
                          },
                        },
                        model: {
                          value: _vm.titleForm.color,
                          callback: function ($$v) {
                            _vm.$set(_vm.titleForm, "color", $$v)
                          },
                          expression: "titleForm.color",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("hPosition"),
                          expression: "showProperty('hPosition')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.text_h_position") },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { size: "mini" },
                          on: {
                            change: function ($event) {
                              return _vm.changeTitleStyle("hPosition")
                            },
                          },
                          model: {
                            value: _vm.titleForm.hPosition,
                            callback: function ($$v) {
                              _vm.$set(_vm.titleForm, "hPosition", $$v)
                            },
                            expression: "titleForm.hPosition",
                          },
                        },
                        [
                          _c("el-radio-button", { attrs: { label: "left" } }, [
                            _vm._v(_vm._s(_vm.$t("chart.text_pos_left"))),
                          ]),
                          _c(
                            "el-radio-button",
                            { attrs: { label: "center" } },
                            [_vm._v(_vm._s(_vm.$t("chart.text_pos_center")))]
                          ),
                          _c("el-radio-button", { attrs: { label: "right" } }, [
                            _vm._v(_vm._s(_vm.$t("chart.text_pos_right"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.showProperty("isItalic") ||
                            _vm.showProperty("isBolder"),
                          expression:
                            "showProperty('isItalic') || showProperty('isBolder') ",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.text_style") },
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          on: {
                            change: function ($event) {
                              return _vm.changeTitleStyle("isItalic")
                            },
                          },
                          model: {
                            value: _vm.titleForm.isItalic,
                            callback: function ($$v) {
                              _vm.$set(_vm.titleForm, "isItalic", $$v)
                            },
                            expression: "titleForm.isItalic",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("chart.italic")) + "\n          "
                          ),
                        ]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          on: {
                            change: function ($event) {
                              return _vm.changeTitleStyle("isBolder")
                            },
                          },
                          model: {
                            value: _vm.titleForm.isBolder,
                            callback: function ($$v) {
                              _vm.$set(_vm.titleForm, "isBolder", $$v)
                            },
                            expression: "titleForm.isBolder",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("chart.bolder")) + "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("letterSpace"),
                          expression: "showProperty('letterSpace')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.letter_space") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: _vm.$t("chart.quota_letter_space"),
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeTitleStyle("letterSpace")
                            },
                          },
                          model: {
                            value: _vm.titleForm.letterSpace,
                            callback: function ($$v) {
                              _vm.$set(_vm.titleForm, "letterSpace", $$v)
                            },
                            expression: "titleForm.letterSpace",
                          },
                        },
                        _vm._l(_vm.fontLetterSpace, function (option) {
                          return _c("el-option", {
                            key: option.value,
                            attrs: { label: option.name, value: option.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("fontShadow"),
                          expression: "showProperty('fontShadow')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.font_shadow") },
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          on: {
                            change: function ($event) {
                              return _vm.changeTitleStyle("fontShadow")
                            },
                          },
                          model: {
                            value: _vm.titleForm.fontShadow,
                            callback: function ($$v) {
                              _vm.$set(_vm.titleForm, "fontShadow", $$v)
                            },
                            expression: "titleForm.fontShadow",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("chart.font_shadow")) + "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("remarkShow"),
                          expression: "showProperty('remarkShow')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.remark") },
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          on: {
                            change: function ($event) {
                              return _vm.changeTitleStyle("remarkShow")
                            },
                          },
                          model: {
                            value: _vm.titleForm.remarkShow,
                            callback: function ($$v) {
                              _vm.$set(_vm.titleForm, "remarkShow", $$v)
                            },
                            expression: "titleForm.remarkShow",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("chart.show")) + "\n          ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.titleForm.remarkShow,
                          expression: "titleForm.remarkShow",
                        },
                      ],
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showProperty("remarkShow"),
                              expression: "showProperty('remarkShow')",
                            },
                          ],
                          staticClass: "form-item",
                          attrs: { label: _vm.$t("chart.remark_edit") },
                        },
                        [
                          _c("el-button", {
                            attrs: {
                              title: _vm.$t("chart.edit"),
                              icon: "el-icon-edit",
                              type: "text",
                              size: "small",
                            },
                            on: { click: _vm.editRemark },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showProperty("remarkShow"),
                              expression: "showProperty('remarkShow')",
                            },
                          ],
                          staticClass: "form-item",
                          attrs: { label: _vm.$t("chart.remark_bg_color") },
                        },
                        [
                          _c("el-color-picker", {
                            staticClass: "color-picker-style",
                            attrs: { predefine: _vm.predefineColors },
                            on: {
                              change: function ($event) {
                                return _vm.changeTitleStyle(
                                  "remarkBackgroundColor"
                                )
                              },
                            },
                            model: {
                              value: _vm.titleForm.remarkBackgroundColor,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.titleForm,
                                  "remarkBackgroundColor",
                                  $$v
                                )
                              },
                              expression: "titleForm.remarkBackgroundColor",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.showEditRemark
        ? _c(
            "el-dialog",
            {
              directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
              staticClass: "dialog-css",
              attrs: {
                title: _vm.$t("chart.remark"),
                visible: _vm.showEditRemark,
                "show-close": false,
                width: "70%",
                "append-to-body": "",
              },
            },
            [
              _c("remark-editor", {
                attrs: {
                  remark: _vm.titleForm.remark,
                  background: _vm.titleForm.remarkBackgroundColor,
                },
                on: { onRemarkChange: _vm.onRemarkChange },
              }),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    { attrs: { size: "mini" }, on: { click: _vm.closeRemark } },
                    [_vm._v(_vm._s(_vm.$t("chart.cancel")) + "\n      ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.changeRemark },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.confirm")) + "\n      ")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }